import { render, staticRenderFns } from "./ActivitiesCalendar.vue?vue&type=template&id=6b201ece&scoped=true&"
import script from "./ActivitiesCalendar.vue?vue&type=script&lang=js&"
export * from "./ActivitiesCalendar.vue?vue&type=script&lang=js&"
import style0 from "./ActivitiesCalendar.vue?vue&type=style&index=0&id=6b201ece&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b201ece",
  null
  
)

export default component.exports